import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersPromocodesUnassignedCountPerDistanceParams, GetVouchersPromocodesUnassignedCountPerDistanceResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";

import axios from "axios";

export const getVouchersPromocodesUnassignedCountPerDistance = createAsyncThunk<
  GetVouchersPromocodesUnassignedCountPerDistanceResponse,
  GetVouchersPromocodesUnassignedCountPerDistanceParams
>(
  `vouchers/getVouchersPromocodesUnassignedCountPerDistance`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersPromocodesUnassignedCountPerDistance({ voucherId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers promocodes unassigned count per distance",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers promocodes unassigned count per distance", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);